<script>
import { mapActions } from "vuex";
import SurveyBuilder from './SurveyBuilder.vue';
import QuestionsView from './QuestionsView';
import sampleQuestionObj from './survey-builder.json';
import ClientFactory from "@/api/ClientFactory";
const surveyApi = ClientFactory.get("surveys");

export default {
  name: 'SurveyMaker',
  data() {
    return {
      questionsList: [],
      addQuestion: false,
      defaultQuestion: '',
      surveyMetadata: {
        name: '',
        description: '',
        is_open: 1,
        topic_id: 2,
        group_account_id: 1 // Group: Toàn bộ nhân viên
      }
    };
  },
  mounted() {
    this.$root.$on('add-update-question', q => {
      console.log(q)
      this.updateQuestionsList(q);
    });
  },
  components: { SurveyBuilder, QuestionsView },
  methods: {
    ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    updateQuestionsList(data) {
      const questionIndex = this.questionsList.findIndex(x => x.id === data.question.id);
      if (questionIndex >= 0) {
        this.questionsList.splice(questionIndex, 1, data.question);
      } else {
        this.questionsList.push(JSON.parse(JSON.stringify(data.question)));
      }
      this.addQuestion = false;
      this.$root.$emit('selected-question', null);
    },
    addNewQuestion() {
      this.defaultQuestion = JSON.parse(JSON.stringify(sampleQuestionObj));
      this.addQuestion = true;
    },
    async saveSurvey() {
      this.loading(this.$vs);
      console.log(JSON.stringify(this.questionsList))
      if(this.questionsList.length ==0) {
        return this.notify({
            error: true,
            text: "Hiện tại khảo sát đang chưa có câu hỏi nào.",
        })
      }
      //process input object
      let questions = this.questionsList.map(q => {
        return { 
          question_text: q.body,
          input_type: this.convertQuestionInputType(q.type),
          options: q.options.map(o=>{
            return { 
              content: o.body
            }
          })
        }
      });

      console.log({
        survey: {
          ...this.surveyMetadata,
          questions: questions
        }
      })

      //send to server
      let response = await surveyApi.createSurvey({
        survey: {
          ...this.surveyMetadata,
          questions: questions
        }
      });
      if(typeof response.error !== 'undefined' || response.data.status === 'failed') {
          this.closeLoading();
          return this.notify({
              error: true,
              text: response.error || response.data.message,
          })
      }
      this.closeLoading();
      this.$router.push('/surveys/list');
    },
    convertQuestionInputType(type) {
      switch(type) {
        case 'SINGLE_CHOICE':
          return 1
        case 'MULTI_CHOICE':
          return 2
        case 'TEXT':
          return 3
        case 'BOOLEAN':
          return 4
        default:
          return 0
      }
    }
  },
  destroyed() {
    this.closeLoading();
  },
};
</script>

<template>
  <div class="survey-maker-containner">
    <CCard>
        <CCardHeader>
            <h4>Tạo khảo sát</h4>
        </CCardHeader>
        <CCardBody>
            <CCard>
              <CCardBody>
                <CInput
                label="Tên khảo sát"
                v-model="surveyMetadata.name"
                placeholder="Điền tên khảo sát"
                />
                <CTextarea
                label="Mô tả"
                v-model="surveyMetadata.description"
                placeholder="Nhập nội dung miêu tả cuộc khảo sát"
                rows="3"
                class="mt-2"
                />
              </CCardBody>
            </CCard>
            <QuestionsView :questions="questionsList" :readOnly="true" />
            <div v-if="addQuestion">
                  <SurveyBuilder :options="defaultQuestion" />
              </div>
              <vs-button square success class="md:mt-2" @click="addNewQuestion"><i class='bx bx-plus-medical'></i> &nbsp; Thêm câu hỏi</vs-button>
        </CCardBody>
        <CCardFooter>
          <div class="text-center">
            <vs-button class="d-inline custom_btn_search" square danger  @click="$router.back()" ><i class='bx bx-left-arrow-alt'></i>&nbsp; Quay lại</vs-button>
            <vs-button square class="d-inline" @click="saveSurvey"><i class='bx bx-save' ></i> &nbsp; Lưu khảo sát</vs-button>
          </div>
        </CCardFooter>
    </CCard>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add_another_btn {
  font-size: 14px;
  background-color: transparent;
  border-color: #4c8ce4;
  color: #4c8ce4;
  padding: 8px;
  cursor: pointer;
}
.text-center {
  text-align: center;
}
</style>
